﻿const defaultOrder = 99999;

const sortByInsuranceMetaOrder = (insurancesByName, metaData, previouslyActiveGroups) => (a, b) => {
    previouslyActiveGroups = typeof previouslyActiveGroups !== 'undefined' && previouslyActiveGroups != null
        ? previouslyActiveGroups
        : [];

    let aOrder, bOrder;
    let insuranceGroupA, insuranceGroupB;

    if (typeof a.groupName !== 'undefined') {
        insuranceGroupA = a.groupName;
    } else { // lookup group name if sorting data that does not contain it as a prop
        insuranceGroupA = a.insuranceName in insurancesByName
            ? insurancesByName[a.insuranceName].groupName
            : null;
    }

    if (typeof b.groupName !== 'undefined') {
        insuranceGroupB = b.groupName;
    } else { // lookup group name if sorting data that does not contain it as a prop
        insuranceGroupB = b.insuranceName in insurancesByName
            ? insurancesByName[b.insuranceName].groupName
            : null;
    }

    aOrder = (insuranceGroupA in metaData
        ? metaData[insuranceGroupA].sortOrder
        : defaultOrder)
            // add offset sum to previously selected groups, if any (i.e. when switching from single purchase to multi), so they are prioritized and remain on top
            + (previouslyActiveGroups.indexOf(insuranceGroupA) === -1
                ? 999999
                : 0);

    bOrder = (insuranceGroupB in metaData
        ? metaData[insuranceGroupB].sortOrder
        : defaultOrder)
            // add offset sum to previously selected groups, if any (i.e. when switching from single purchase to multi), so they are prioritized and remain on top
            + (previouslyActiveGroups.indexOf(insuranceGroupB) === -1 
                ? 999999
                : 0);

    return aOrder < bOrder ? -1 : 1;
};

export default sortByInsuranceMetaOrder;